import React from 'react';
import Select from 'corp/components/UI/Select';
import { CountryCode } from '@scale/shared/types/demographics';

const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });

const SelectCountry = (props: $FIXME) => {
  const countries = Object.values(CountryCode).map(value => ({
    label: regionNames.of(value),
    value,
  }));
  return <Select {...props} options={countries} placeholder="Select Country" />;
};
export default SelectCountry;
